var exports = {
  "Qs": "CameraPreviewModal.module__content___dVI3ZG",
  "Wc": "CameraPreviewModal.module__backgroundSection___dVI3ZG",
  "Pz": "CameraPreviewModal.module__backgroundLabel___dVI3ZG",
  "Ip": "CameraPreviewModal.module__effectStrengthSlider___dVI3ZG",
  "TM": "CameraPreviewModal.module__effectStrengthLabelRow___dVI3ZG",
  "dI": "CameraPreviewModal.module__effectStrengthLabel___dVI3ZG",
  "j": "CameraPreviewModal.module__videoContainer___dVI3ZG",
  "qr": "CameraPreviewModal.module__footer___dVI3ZG",
  "wu": "CameraPreviewModal.module__footerStart___dVI3ZG",
  "Dr": "CameraPreviewModal.module__footerMirrorSwitch___dVI3ZG",
  "Ki": "CameraPreviewModal.module__video___dVI3ZG",
  "CT": "CameraPreviewModal.module__mirroredVideo___dVI3ZG",
  "Lw": "CameraPreviewModal.module__overlay___dVI3ZG",
  "um": "CameraPreviewModal.module__overlayText___dVI3ZG",
  "nU": "CameraPreviewModal.module__overlayTextMedium___dVI3ZG",
  "$q": "CameraPreviewModal.module__errorOverlay___dVI3ZG",
  "kc": "CameraPreviewModal.module__errorText___dVI3ZG",
  "JU": "CameraPreviewModal.module__errorTitle___dVI3ZG",
  "m2": "CameraPreviewModal.module__errorDetail___dVI3ZG",
};

module.exports = exports;
